import * as React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export function handleErrors(response: Response) {
  console.log("Calling handleErrors.");
  console.log("Response: ", response);

  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function postFetchJSON(
  url: string,
  body: { [key: string]: string },
): Promise<object> {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "same-origin",
  }).then((req) => {
    return req.json();
  });
}

export function getJSON<T = object>(url: string): Promise<T> {
  return fetch(url, {
    method: "GET",
    credentials: "same-origin",
  }).then((req) => {
    return req.json();
  });
}

export interface OkResponse {
  ok: boolean;
}

/**
 * Takes a GraphQL error string as argument. Parses the errors and
 * returns readable HTML. If the error string is not JSON parsable, it will return the
 * default error message.
 */
export function handleVmGraphQLErrors(
  error: string,
  default_error_message?: string,
) {
  const divStyle =
    "tw-bg-red-light-1 tw-border-[1px] tw-border-solid tw-border-red-1 tw-p-[5px] tw-w-fit tw-rounded-md tw-text-[14px] tw-flex tw-justify-center";
  let parsedJSON;
  try {
    parsedJSON = JSON.parse(error);
  } catch (e) {
    return (
      <div className={divStyle}>
        {`${
          default_error_message ?? error
        }. Please contact Verse Medical if you continue to experience this issue.`}
      </div>
    );
  }
  return (
    <div className={divStyle}>
      <>
        {Object.entries(parsedJSON).map(([key, val]): React.ReactNode => {
          return (
            <div>
              <span className="tw-font-bold">
                <FontAwesomeIcon
                  icon={faXmark}
                  className="tw-mr-[3px] tw-text-red-1"
                />
                {key}
                {": "}
              </span>
              <span>{val as string}</span>
            </div>
          );
        })}
      </>
    </div>
  );
}
